<!--  -->
<template>
<div class='home'>
    <div class="bgpic" ><img :style="ratio?{width:'100%',height:'auto'}:''" :src="isMobile?require('@/assets/images/mobile/bg.jpg'):require('@/assets/images/bg.jpg')" alt=""></div>
    <div class="logo"><img src="@/assets/images/name.png" alt=""></div>
    <div class="video" v-if="videoshow && !isMobile && video"><video id="media" :style="ratio?{width:'auto',height:'100%'}:''" src="static/bg.mp4" autoplay muted></video></div>
    <Aside v-if="state || isMobile"></Aside>
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import browser from '@/utils/browser.js'
import aside from '@/components/layout/aside.vue'
export default {
//import引入的组件需要注入到对象中才能使用
components: {
    'Aside':aside,
    

},
data() {
//这里存放数据
return {
    isMobile:browser.mobile,
    videoshow:true,
    video:false,
    state:true,
    default: 1920 /1080,
    ratio:true,//长宽比小于原始长宽比1920/1080   
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {
    default(val) {
        var sratio = 1920 / 1080 ;
        if(sratio < val) {
            this.ratio = false;
        }else this.ratio = true
        }
},
//方法集合
methods: {

},
//生命周期 - 创建完成（可以访问当前this实例）
created() {
    this.video = this.$store.state.video
},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
    this.default = document.body.clientWidth/document.body.clientHeight
     if(this.video) {
         document.getElementById('media').addEventListener('ended', () => { //该视频播放是否已结束
         this.videoshow = false
         this.state = true
         this.$store.commit('getVideo',false)
       }, false)
     }else {
         this.state = true
     }
    
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.home {
    position:relative;
    width:100%;
    height:100%;
    overflow:hidden;
    .bgpic {
        position:absolute;
        top:0;
        left:0;
        width:100%;
        height:100%;
        display:flex;
        justify-content: center;
        align-items:center;
    }
    .logo {
        position:absolute;
        width:49.4vw;
        top:19.9vh;
        left:0;
        right:0;
        margin:auto;
        animation:shake 1s linear;
        /* animation:bounceInLeft 2s 0.25s linear forwards; */
    }
    .video {
        position:absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        top:0;
        left:0;
        width:100%;
        height:100%;
        video {
            width:100%;
            height:auto;
        }
    }
}
@keyframes shake {
		0%{
			transform: scale(0);
		}
		30%{
			transform: scale(0.3);
		}
		40%{
			transform: scale(0.4);
		}
		50%{
			transform: scale(0.5);
		}
		60%{
			transform: scale(0.7);
		}
		70%{
			transform: scale(0.9);
		}
		90%{
			transform: scale(1);
		}
		100%{
			transform: scale(1);
		}
	}
    @keyframes bounceInLeft {
        from, 60%, 75%, 90%, to {animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);}
        0% {opacity: 0;transform: translate3d(-3000px, 0, 0);}
        60% {opacity: 1;transform: translate3d(25px, 0, 0);}
        75% {transform: translate3d(-10px, 0, 0);}
        90% {transform: translate3d(5px, 0, 0);}
        100% {opacity: 1;transform: none;}
    }
    @media screen and (max-width:600px) {
        .home .logo {
            width:74.8vw;
            top:13.5vh;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/home/index.vue